import http from "../../utils/http";
import { toast } from "../../utils/toast";
// 품목 등록하기
export const postProducts = (data) => {
  return new Promise((resolve, reject) => {
    http
      .post("/products", data)
      .then((res) => {
        toast.success('품목이 등록되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 품목조회
export const getProductsList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/products/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// {
//   "search": {
//     "category": "품목"
//   },
//   "order": [
//     {
//       "idx": "asc"
//     }
//   ],
//   "offset": 0,
//   "limit": 100
// }

// 품목 일괄 삭제
export const deleteProducts = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete("/products", { data: data })
      .then((res) => {
        toast.success('품목 일괄 삭제되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 품목 엑셀 다운로드
export const getProductsDownloadExcel = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/products/excel", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 품목 엑셀 샘플 다운로드
export const getProductsDownloadExcelSample = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/products/excel/sample")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 품목 일괄 등록하기
export const postProductsMultiple = (data) => {
  return new Promise((resolve, reject) => {
    http
      .post("/products/multiple", data)
      .then((res) => {
        toast.success('품목 일괄 등록되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 품목 일괄 수정하기
export const putProductsMultiple = (data) => {
  return new Promise((resolve, reject) => {
    http
      .put("/products", data)
      .then((res) => {
        toast.success('품목 일괄 수정되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 품목 수정하기
export const putProducts = (idx, data) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/products/${idx}`, data)
      .then((res) => {
        toast.success(`${data.name}품목이 수정되었습니다.`)
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 품목 히스토리 조회
export const getProductsHistoryList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/products/history/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};